import * as THREE from "three";
import { FBXLoader } from "./customFbxLoader.js";

// ignoreTextures allows us to skip texture loading from server, that flag is handled in customFbxLoader
const dummyManager = {
    resolveURL: function(str) {return str;},
    itemStart: function(){},
    itemEnd: function(){},
    ignoreTextures: true,
}

let fbxLoader = new FBXLoader(dummyManager);
fbxLoader.setWithCredentials(true);

export function parseFbx(data) {
    let parseResult = fbxLoader.parse(data, "");
    let fbxModel = parseResult.sceneGraph;

    let materials = Array.from(parseResult.materials);
    let usedImages = {};
    let problemImages = {};
    for (let i = 0; i < materials.length; i++) {
        let elem = materials[i];

        if (elem[1].map == null) {
            problemImages[elem[1].name] = "Map is null"
        } else {
            usedImages[elem[1].name] = elem[1].map.fileName;
        }
    }

    let result = {
        problemScaleMeshes: [],
        problemImages: problemImages,
        usedImages: usedImages,
        animations: fbxModel.animations,
        missingLodIndexes: [],
        notLodMeshes: [],
    };

    function isWrongScale(scale) {
        function isWrong(value) {
            return Math.abs(1 - value) > 0.01;
        }

        return isWrong(scale.x) || isWrong(scale.y) || isWrong(scale.z);
    }

    function extractLodLevel(str) {
        const regex = /_LOD(\d+)$/;
        const match = regex.exec(str);
        if (match && match[1]) {
            const number = parseInt(match[1], 10);
            if (!isNaN(number) && number >= 0) {
                return number; // Return the captured non-negative number.
            }
        }

        return null;
    }

    if (isWrongScale(fbxModel.scale))
        result.problemScaleMeshes.push({
            name: fbxModel.name,
            scale: fbxModel.scale,
        });

    let lodLevels = new Set();
    let meshes = parseResult.sceneGraph.children;
    let meshesCount = 0;
    let notLodMeshes = [];
    for (const item of meshes) {
        let lodLevel = extractLodLevel(item.name);
        if (lodLevel !== null) {
            if (isWrongScale(item.scale)) {
                result.problemScaleMeshes.push({
                    name: item.name,
                    scale: item.scale,
                });
            }
            lodLevels.add(lodLevel);
        } else if (item.type !== "AmbientLight") {
            notLodMeshes.push(item.type + " " + item.name);
        }
    }

    for (let i = 0; i < lodLevels.size; i++) {
        if (!lodLevels.has(i)) {
            result.missingLodIndexes.push(i);
        }
    }
    if (lodLevels.size > 0 && notLodMeshes.length > 0) {
        result.notLodMeshes = notLodMeshes;
    }

    const box = new THREE.Box3().setFromObject(fbxModel);
    let size = new THREE.Vector3(0, 0, 0);
    box.getSize(size);

    if (
        "UnitScaleFactor" in parseResult.globalSettings &&
        parseResult.globalSettings.UnitScaleFactor.value
    ) {
        size.multiplyScalar(parseResult.globalSettings.UnitScaleFactor.value);
    }

    result.size = size;
    fbxModel = null;
    return result;
}

export function loadModelMetadata(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            try {
                let parseResult = parseFbx(reader.result);

                resolve({
                    Width: parseResult.size.x / 100,
                    Height: parseResult.size.z / 100,
                    Tallness: parseResult.size.y / 100,
                    MaterialsMap: parseResult.usedImages,
                });
            } catch (e) {
                reject(e.message);
            }
        };

        reader.readAsArrayBuffer(file);
    });
}
